/**
 * Palette token constants for the service-request feature.
 *
 * These resolve to CSS custom properties defined in tokens.css.
 * Import from here rather than declaring the same string in every component.
 */

export const PALETTE_FOREST = 'hsl(var(--palette-forest, 176 72% 17%))';
export const PALETTE_AMBER  = 'hsl(var(--palette-amber,   33 100% 50%))';
export const PALETTE_MINT   = 'hsl(var(--palette-mint,   154  38% 94%))';
export const PALETTE_CREAM  = 'hsl(var(--palette-cream,   40 100% 98%))';
